module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/182.84da3259.png";